import React from "react";
import classNames from "classnames";
import type { ButtonProps } from "antd/lib/button";
import { AppButton } from "../../AppButton";
import baseBtn from "../styles.module.scss";
import styles from "./styles.module.scss";

export const SaveButton: React.FC<ButtonProps> = ({ children, className, ...props }) => {
  return (
    <AppButton
      className={classNames(baseBtn["contacts-btn"], styles["save-btn"], className)}
      {...props}
    >
      {children}
    </AppButton>
  );
};
